/* Bella Ballou: dynamisk fri fragt-bar (snippets/bb-free-shipping-bar.liquid) */
if (!customElements.get('bb-free-shipping-bar')) {
  class BbFreeShippingBar extends HTMLElement {
    // Shared in-flight request so several bars (drawer, cart page, announcement) fetch /cart.js once.
    static fetchCart() {
      if (!BbFreeShippingBar.pending) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        BbFreeShippingBar.pending = fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error(`cart.js ${response.status}`);
            return response.json();
          })
          .finally(() => {
            BbFreeShippingBar.pending = null;
          });
      }
      return BbFreeShippingBar.pending;
    }

    connectedCallback() {
      this.message = this.querySelector('.bb-free-shipping-bar__message');
      this.track = this.querySelector('.bb-free-shipping-bar__track');
      this.fill = this.querySelector('.bb-free-shipping-bar__fill');

      // Re-render client-side so the threshold is converted to the presentment currency.
      this.update(parseInt(this.dataset.total, 10) || 0);
      // Server-renderet beløb sammenlignede DKK-tærsklen med kurvens præsentationsvaluta; først nu er det korrekt.
      this.removeAttribute('data-pending');

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      this.unsubscribe = null;
    }

    refresh() {
      return BbFreeShippingBar.fetchCart()
        .then((cart) => {
          if (this.isConnected && cart) this.update(cart.total_price);
        })
        .catch((error) => console.error(error));
    }

    get rate() {
      return window.BbMoney ? window.BbMoney.rate : 1;
    }

    // Beløbsformatering ligger i assets/bb-money.js, delt med Levering-fanen.
    formatMoney(cents) {
      return window.BbMoney ? window.BbMoney.format(cents) : String(Math.round(cents / 100));
    }

    update(total) {
      const threshold = Math.round((parseInt(this.dataset.threshold, 10) || 0) * this.rate);
      const remaining = Math.max(threshold - total, 0);
      const progress = threshold > 0 ? Math.min(Math.floor((total / threshold) * 100), 100) : 100;
      const reached = remaining === 0;

      this.dataset.total = total;
      this.classList.toggle('bb-free-shipping-bar--reached', reached);

      if (this.message) {
        this.message.replaceChildren();
        if (reached) {
          this.message.textContent = this.dataset.textReached || '';
        } else {
          const parts = (this.dataset.textRemaining || '').split('[amount]');
          parts.forEach((part, index) => {
            if (index > 0) {
              const amount = document.createElement('span');
              amount.className = 'bb-free-shipping-bar__amount';
              amount.textContent = this.formatMoney(remaining);
              this.message.appendChild(amount);
            }
            if (part) this.message.appendChild(document.createTextNode(part));
          });
        }
      }

      if (this.fill) this.fill.style.width = `${progress}%`;
      if (this.track) {
        this.track.setAttribute('aria-valuenow', progress);
        if (this.message) this.track.setAttribute('aria-valuetext', this.message.textContent.trim());
      }
    }
  }

  customElements.define('bb-free-shipping-bar', BbFreeShippingBar);
}
